import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { FiUsers, FiClock, FiCreditCard, FiTrendingUp, FiAlertTriangle, FiPlus, FiFileText } from 'react-icons/fi';

const StatCard = ({ icon: Icon, label, value, color, bg }) => (
  <div className="stat-card">
    <div className="stat-icon" style={{ background: bg, color }}><Icon size={20} /></div>
    <div className="stat-value">{value}</div>
    <div className="stat-label">{label}</div>
  </div>
);

const statusBadge = (status) => {
  const map = { paid: 'badge-success', pending: 'badge-warning', partial: 'badge-info' };
  return <span className={`badge ${map[status] || 'badge-gray'}`}>{status}</span>;
};

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard/stats').then(r => { setStats(r.data.stats); setLoading(false); });
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div>
      {/* Quick Actions */}
      <div style={{ display:'flex', gap:10, marginBottom:24, flexWrap:'wrap' }}>
        <Link to="/customers/add" className="btn btn-accent">
          <FiPlus size={15} /> New Customer
        </Link>
        <Link to="/bills/create" className="btn btn-primary">
          <FiFileText size={15} /> Create Bill
        </Link>
      </div>

      {/* Stats */}
      <div className="stats-grid">
        <StatCard icon={FiUsers} label="Total Customers" value={stats?.totalCustomers || 0}
          color="#3b82f6" bg="#dbeafe" />
        <StatCard icon={FiClock} label="Pending Orders" value={stats?.pendingOrders || 0}
          color="#f59e0b" bg="#fef3c7" />
        <StatCard icon={FiCreditCard} label="Today's Sales" value={`SAR ${(stats?.todaySales || 0).toFixed(0)}`}
          color="#10b981" bg="#d1fae5" />
        <StatCard icon={FiTrendingUp} label="Monthly Revenue" value={`SAR ${(stats?.monthRevenue || 0).toFixed(0)}`}
          color="#8b5cf6" bg="#ede9fe" />
        <StatCard icon={FiAlertTriangle} label="Low Stock Items" value={stats?.lowStockCount || 0}
          color="#ef4444" bg="#fee2e2" />
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
        {/* Recent Bills */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Recent Bills</h3>
            <Link to="/bills" className="btn btn-outline btn-sm">View All</Link>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Bill #</th>
                  <th>Customer</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {stats?.recentBills?.length === 0 && (
                  <tr><td colSpan={4}><div className="empty-state" style={{padding:'20px'}}>No bills yet</div></td></tr>
                )}
                {stats?.recentBills?.map(bill => (
                  <tr key={bill._id}>
                    <td><Link to={`/bills/${bill._id}`} style={{ color:'#3b82f6', fontWeight:600 }}>#{bill.billNumber}</Link></td>
                    <td>{bill.customerName}</td>
                    <td>SAR {bill.total?.toFixed(0)}</td>
                    <td>{statusBadge(bill.status)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Low Stock Alert */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">⚠️ Low Stock Alert</h3>
            <Link to="/inventory" className="btn btn-outline btn-sm">Manage</Link>
          </div>
          <div className="card-body">
            {!stats?.lowStockProducts?.length ? (
              <div style={{ color:'#10b981', textAlign:'center', padding:16 }}>✅ All stock levels are OK</div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {stats.lowStockProducts.map(p => (
                  <div key={p._id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 12px', background:'#fee2e2', borderRadius:6 }}>
                    <span style={{ fontWeight:500 }}>{p.name}</span>
                    <span className="badge badge-danger">{p.stockQty} left</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}